import { ThemeInterface } from "@styles/theme";

export const styles = (theme: ThemeInterface) => ({
	root: {
		color: `${theme.palette.primary.main}`,
		height: "24px",
		width: "340px",
		position: "relative",
		left: "14px",
	},
	thumb: {
		height: 24,
		width: 24,
		backgroundColor: theme.palette.common.white,
		border: "2px solid currentColor",
		marginTop: 0,
		"&:focus, &:hover, &$active": {
			boxShadow: "inherit",
		},
	},
	active: {},
	valueLabel: {
		left: "calc(-50% + 4px)",
		fontSize: "10px",
		lineHeight: 1.2,
		background: "unset",
		padding: 0,
		width: 32,
		height: 32,
		borderRadius: "50% 50% 50% 0",
		backgroundColor: `${theme.palette.primary.main}`,
		transformOrigin: "bottom left",
		transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
		"&:before": { display: "none" },
		"&.MuiSlider-valueLabelOpen": {
			transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
		},
		"& > *": {
			transform: "rotate(45deg)",
		},
	},
	markLabel: {
		top: "40px",
		fontSize: "12px",
		lineHeight: "1.67",
		letterSpacing: "0.3px",
		color: "#747c97",
	},
	track: {
		height: "22px",
		borderRadius: 4,
	},
	rail: {
		height: "24px",
		borderRadius: 12,
	},
});

export default styles;
